import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseApiService } from '../../shared/base-service/base-api.service';
import { CorrespondenceTemplateVersion } from '../models/template-version.model';
import { CorrespondenceTemplateType } from '../models/correspondence-template-type.model';

@Injectable()
/**
 * CRUD operations for interacting with correspondence templates
 */
export class CorrespondenceTemplateService extends BaseApiService {

    /**
	 * Returns all Template Types
	 * @param includeInactive
	 */
    getCorrespondenceTemplateTypes(includeInactive: boolean): Observable<CorrespondenceTemplateType[]> {
        return this.get(`Correspondence/Template/GetAllTypes/${includeInactive}`);
    }

    /**
	 * Gets all Template Versions
	 * @param includeInactive
	 */
    getAllCorrespondenceTemplateVersions(includeInactive: boolean): Observable<CorrespondenceTemplateVersion[]> {
        return this.get(`Correspondence/Template/AllVersions/${includeInactive}`);
    }

    /**
	 * Gets all available correspondence templates
	 * @param name
	 */
    searchCorrespondenceTemplateTypes(name: string): Observable<CorrespondenceTemplateType[]> {
        return this.get(`Correspondence/Template/Search/${name}`);
    }

    getCorrespondenceTemplateTypeByNameExact(name: string): Observable<CorrespondenceTemplateType> {
        return this.get(`Correspondence/Template/SearchExact/${name}`);
    }

    /**
     * Gets a specific correspondence template type
     * @param templateTypeId
     */
    getCorrespondenceTemplateType(templateTypeId: number): Observable<CorrespondenceTemplateType> {
        return this.get(`Correspondence/Template/Detail/${templateTypeId}`);
    }

    /**
     * Gets a specific correspondence template version
     * @param correspondenceTemplateVersionId
     */
    getCorrespondenceTemplateVersion(correspondenceTemplateVersionId: number): Observable<CorrespondenceTemplateVersion> {
        return this.get(`Correspondence/Template/TemplateVersion/${correspondenceTemplateVersionId}`);
    }

    /**
     * Gets all versions of a specific correspondence template
     * @param templateTypeId
     */
    getCorrespondenceTemplateVersions(templateTypeId: number): Observable<CorrespondenceTemplateVersion[]> {
        return this.get(`Correspondence/Template/Versions/${templateTypeId}`);
    }

    /**
     * Returns the current version of the template
     * @param correspondenceTemplateTypeId
     */
    getCorrespondenceTemplateCurrentVersion(correspondenceTemplateTypeId: number): Observable<CorrespondenceTemplateVersion> {
        return this.get(`Correspondence/Template/${correspondenceTemplateTypeId}/Current`);
    }

    /**
     * Gets the contents of a correspondence template version
     * @param correspondenceTemplateVersionId
     */
    getCorrespondenceTemplateVersionContentAsString(correspondenceTemplateVersionId: number): Observable<string> {
        return this.get(`Correspondence/Template/VersionContentAsString/${correspondenceTemplateVersionId}`);
    }

    /**
     * Gets the Url used to upload a new version of a correspondence template
     * @param correspondenceTemplateId
	 * @param isPii
     */
    addCorrespondenceTemplateVersion(correspondenceTemplateId: number, isPii: boolean, isOverwrite: boolean, content: string): Observable<number> {
        return this.post(`Correspondence/Template/Version/${correspondenceTemplateId}/${isPii}/${isOverwrite}`, content);
    }

    /**
	 * Saves a template type
	 * @param model
	 */
    saveCorrespondenceTemplateVersion(model: CorrespondenceTemplateVersion): Observable<number> {
        return this.post('Correspondence/Template/UpdateVersion', model);
    }

    /**
     * Saves a template type
     * @param model
     */
    saveCorrespondenceTemplateType(model: CorrespondenceTemplateType): Observable<any> {
        return this.post('Correspondence/Template/Update', model);
    }
}
